"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var reduce_1 = tslib_1.__importDefault(require("lodash/reduce"));
var types = tslib_1.__importStar(require("./action-types"));
exports.ROOT_KEY = 'programs';
var DEFAULT_STATE = {
    views: {},
    viewsLastFetched: null
};
exports.setProgramViews = function (state, programViews) {
    if (programViews === void 0) { programViews = []; }
    return (tslib_1.__assign({}, state, { views: reduce_1.default(programViews, function (result, program) {
            if (program === void 0) { program = {}; }
            var _a;
            var programViewId = program.programViewId || program.programId;
            if (!programViewId) {
                return result;
            }
            return tslib_1.__assign({}, result, (_a = {}, _a[programViewId] = tslib_1.__assign({}, result[programViewId], { program: tslib_1.__assign({}, program) }), _a));
        }, state.views) }));
};
exports.setProgramViewsLastFetched = function (state) { return (tslib_1.__assign({}, state, { viewsLastFetched: Date.now() })); };
function programs(state, action) {
    if (state === void 0) { state = DEFAULT_STATE; }
    switch (action.type) {
        case types.USER_SET_ELIGIBLE_PROGRAMS:
        case types.PROGRAMS_SET_PROGRAM_VIEWS:
            return exports.setProgramViews(state, action.programs);
        case types.PROGRAM_VIEWS_SET_LAST_FETCHED:
            return exports.setProgramViewsLastFetched(state);
    }
    return state;
}
exports.default = programs;
//# sourceMappingURL=reducers.js.map